import React from "react";
import { Table, Badge, Card } from "react-bootstrap";

function TaskTable() {

  // ✅ DATA INSIDE SAME COMPONENT
  const tasks = [
    {
      id: "Emp-001",
      task: "Payment Gateway",
      project: "Educational Platform",
      createdDate: "12 Sep 2024",
      deadline: "12 Sep 2024",
      priority: "Low",
      status: "Active",
    },
    {
      id: "Emp-002",
      task: "API Integration",
      project: "HR System",
      createdDate: "10 Sep 2024",
      deadline: "15 Sep 2024",
      priority: "Medium",
      status: "Inactive",
    },
    {
      id: "Emp-003",
      task: "UI Design",
      project: "Finance App",
      createdDate: "08 Sep 2024",
      deadline: "20 Sep 2024",
      priority: "High",
      status: "Active",
    },
  ];

  const getPriority = (priority) => {
    switch (priority) {
      case "Low":
        return "success";
      case "Medium":
        return "warning";
      case "High":
        return "danger";
      default:
        return "secondary";
    }
  };

  const getStatus = (status) => {
    return status === "Active" ? "success" : "danger";
  };

  return (
    <Card className="p-3 shadow-sm border-0">

      <h5 className="mb-3 fw-bold">Task Table</h5>

      <Table striped hover responsive className="text-center align-middle">

        <thead className="table-light">
          <tr>
            <th>Emp ID</th>
            <th>Task Name</th>
            <th>Project Name</th>
            <th>Created Date</th>
            <th>Deadline</th>
            <th>Priority</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {tasks.map((t, i) => (
            <tr key={i}>
              <td>{t.id}</td>
              <td>{t.task}</td>
              <td>{t.project}</td>
              <td>{t.createdDate}</td>
              <td>{t.deadline}</td>

              <td>
                <Badge bg={getPriority(t.priority)}>
                  {t.priority}
                </Badge>
              </td>

              <td>
                <Badge bg={getStatus(t.status)}>
                  {t.status}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>

      </Table>
    </Card>
  );
}

export default TaskTable;